import React from 'react';
import { AnimatedSpinner } from './animated-spinner';

import './animated-spinner-full-screen.scss';

export const AnimatedSpinnerFullScreen: React.FC = (): React.ReactElement => {
    return (
        <div className="animated-spinner-full-screen">
            <AnimatedSpinner />
        </div>
    );
};
